import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CUSTOM_THEME, Tr } from '@utils';
import { PackageDeal } from '@services';
import { LightCardWithTitle } from '@components/common';
import { Box, Chip, Stack, Typography } from '@mui/material';

export interface IWizardPackageOptionCardProps {
	packageDeal?: PackageDeal;
	recommended?: boolean;
	selected?: boolean;
	onSelect?: () => void;
}

export const WizardPackageOptionCard: FC<IWizardPackageOptionCardProps> = ({ packageDeal, recommended, selected, onSelect, children }) => {
	const { t } = useTranslation('portal');
	const titleText = [t(recommended ? 'wizard.suggestions.option-first' : 'wizard.suggestions.option-second'), packageDeal?.name]
		.filter(Boolean)
		.join(' - ');

	return (
		<LightCardWithTitle
			className="electrification-wizard-option" // GTM tag trigger
			headerVariant="dark"
			title={
				<Stack direction="row" alignItems="center" spacing={2}>
					<Box
						sx={{
							minWidth: 24,
							maxWidth: 24,
							minHeight: 24,
							maxHeight: 24,
							borderRadius: '50%',
							backgroundColor: 'common.white',
							borderColor: 'primary.main',
							borderStyle: 'solid',
							borderWidth: selected ? 7 : 2
						}}
					/>
					<Typography variant="h5" sx={{ fontWeight: 'bold' }}>
						{titleText}
					</Typography>
				</Stack>
			}
			headerTypographyProps={{ component: 'div' }}
			actionButton={
				recommended ? (
					<Chip
						sx={{ borderRadius: 1.25, maxHeight: 24 }}
						label={<Tr.Portal path="wizard.suggestions.recommended" />}
						color="primary"
					/>
				) : null
			}
			headerProps={{ sx: { minHeight: 80, paddingX: 3, paddingY: 0, cursor: 'pointer' }, onClick: onSelect }}
			contentProps={{ sx: { padding: 3, backgroundColor: selected ? '#f4fbfc' : undefined } }}
			sx={{
				height: 1.0,
				boxShadow: selected ? `0 0 0 2px ${CUSTOM_THEME.palette.primary.main}` : undefined,
				borderColor: selected ? 'primary.main' : undefined
			}}
		>
			{children}
		</LightCardWithTitle>
	);
};
